import React, { CSSProperties } from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.svg<{ rotate?: number }>`
  width: var(--icon-size);
  height: var(--icon-size);
  transform: rotate(${(props) => props.rotate || 0}deg);
`;

interface Props {
  className?: string;
  fill?: string;
  rotate?: number;
  style?: CSSProperties;
}

export const ArrowIcon: React.FC<Props> = ({
  className,
  rotate,
  fill = "#16A26E",
  style,
}) => {
  return (
    <StyledRoot
      style={style}
      className={className}
      rotate={rotate}
      focusable="false"
      viewBox="0 0 20 20"
      aria-hidden="true"
    >
      <path
        d="M10.0002 3.33301L8.82516 4.50801L13.4752 9.16634H3.3335V10.833H13.4752L8.82516 15.4913L10.0002 16.6663L16.6668 9.99967L10.0002 3.33301Z"
        fill={fill}
      />
    </StyledRoot>
  );
};
